import React, { useState } from "react";
import { icons } from "../../constants";
import {
  callApiAsync,
  postLoadEngineeringReportFile
} from "../../services/apiService";

const FileUpload = ({ id, setResult, rowData, icon, onFinish }) => {
  const [loading, setLoading] = useState(false);
  const finalId = id || `upload-${new Date().getTime()}`;

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setLoading(true);
    await uploadEnginnerReportPDF(
      file,
      rowData,
      async (fileName, originalName, path) => {
        if (setResult) {
          setResult({ fileName, originalName, path, rowData });
        }
        setLoading(false);
      },
      onFinish
    );
  };

  return (
    <label htmlFor={finalId}>
      <input
        id={finalId}
        type="file"
        name="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
        accept=".pdf"
      />
      <div className="eye-btn">
        <img
          className="btn-material-icon"
          src={icon || icons.evidencia}
          alt="upload"
        />
      </div>
    </label>
  );
};

const uploadEnginnerReportPDF = async (file, rowData, callback, onFinish) => {
  const extension = file.name
    .substring(file.name.lastIndexOf("."))
    .toLowerCase();
  if (extension !== ".pdf") {
    alert("Solo se permiten archivos PDF");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("engineeringActId", rowData.id);

  await callApiAsync(
    () => postLoadEngineeringReportFile(formData),
    () => {
      setTimeout(() => {
        if (onFinish) onFinish();
      }, 500);
    },
    (err) => {
      console.error("Error uploading file:", err);
    }
  );
  return true;
};

export default FileUpload;
